export const sleep = (delay: number) =>
  new Promise((resolve: (value?: unknown) => void) => {
    setTimeout(() => resolve(), delay);
  });

export const removeTrailingSlashes = (path: string) => path.replace(/\/+$/, '');
